import React from 'react';
import './LoginPage.scss';
import { Button, Input } from 'antd';
import { ReactComponent as CrystoIcon } from 'assets/icons/Crysto.svg';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from 'store/store';
import { asyncLoginUser } from 'store/reducers/users/thunks';
import { ILoginForm } from 'store/reducers/users/types';

function LoginPage(): React.ReactElement {
    const dispatch = useAppDispatch();

    const navigate = useNavigate();
    const [form, setForm] = React.useState<ILoginForm>({
        username: '',
        password: '',
    });
    const authorize = React.useCallback(() => {
        dispatch(asyncLoginUser(form))
            .unwrap()
            .then(() => {
                if (localStorage.token) {
                    navigate('/');
                }
            });
    }, [dispatch, form, navigate]);

    return (
        <div className="login-form">
            <CrystoIcon />
            <Input
                value={form.username}
                onChange={e => setForm({ ...form, username: e.target.value })}
                placeholder="Логин"
            />
            <Input
                value={form.password}
                onChange={e => setForm({ ...form, password: e.target.value })}
                placeholder="Пароль"
                type="password"
                onKeyDown={event => {
                    if (event.key === 'Enter') authorize();
                }}
            />
            <Button onClick={authorize}>Войти</Button>
        </div>
    );
}

export default React.memo(LoginPage);
